import { X } from 'lucide-react';
import { Dialog } from 'radix-ui';

import { ConfigPanel } from '@/components/panels/ConfigPanel';
import { Button } from '@/components/ui/button';

/**
 * Tiroir latéral (gauche) contenant le panneau de configuration.
 * Contrôlé de l'extérieur (bouton « Configurer » du header, ou lignes-résumé
 * du dashboard) : `open`/`onOpenChange` pilotent l'ouverture, `defaultTab`
 * l'onglet initial. Se superpose aux graphiques avec un fond assombri.
 */
export function ConfigDrawer({
  open,
  onOpenChange,
  defaultTab,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultTab?: string;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content
          aria-describedby={undefined}
          className="fixed inset-y-0 left-0 z-50 flex h-full w-full flex-col border-r bg-background shadow-lg duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:w-1/2 sm:min-w-[520px]"
        >
          <div className="flex items-center justify-between border-b p-4">
            <Dialog.Title className="text-base font-semibold">Configuration</Dialog.Title>
            <Dialog.Close asChild>
              <Button variant="ghost" size="icon-sm" aria-label="Fermer la configuration">
                <X />
              </Button>
            </Dialog.Close>
          </div>
          <div className="flex-1 overflow-y-auto p-4">
            {open && <ConfigPanel key={defaultTab} defaultTab={defaultTab} />}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
